<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Treatment Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Treatment Code</label>
                <input type="text" class="form-control" v-model="treatment.name" id="name" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label>Price</label>
                <input type="number" class="form-control" v-model="treatment.price" id="price" aria-describedby="price">
            </div>
            <div class="form-group col-3">
                <label>Raw Material Price</label>
                <input type="number" class="form-control" v-model="treatment.rawMaterialPrice" id="price" aria-describedby="rawMaterialPrice">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Treatment Name</label>
                <textarea class="form-control" id="desc-textarea" v-model="treatment.remarks" rows="2"></textarea>
            </div>
        </div>
        <button v-if="this.role === 'admin' || this.role === ''" type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Treatment } from '../../models/treatment'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            treatment: {
                ...Treatment,
            },
            role: '',
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const treatmentApi = api('treatment/detail')

            // const treatmentResult = await treatmentApi.getWithParams(this.$route.query.id)
            // this.treatment = treatmentResult

            const treatmentResult = await treatmentApi.getWithParams(this.$route.query.id)
            this.treatment = treatmentResult[0]
            this.role = treatmentResult[1]
        }
    },
    methods: {
        async save() {
            const treatmentApi = api('treatment')
            if(this.$route.query.id !== undefined) {
                await treatmentApi.update(this.treatment, this.$route.query.id)
            } else {
                await treatmentApi.create(this.treatment)
            }
            this.$router.push({ name: 'treatment' })
        },
        cancel() {
            this.$router.push({ name: 'treatment' })
        },
        finishLookup(data) {
            const currentTreatment = this.treatment
            this.treatment = {
                ...currentTreatment,
                ...data
            }
        },
        selectChange(data) {
            const currentTreatment = this.treatment
            this.treatment = {
                ...currentTreatment,
                ...data
            }
        },
    }
}
</script>